import React, { useCallback } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import { useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator';

export default function SaicaGoalStateWarning(props) {
  const { plantObligationID } = props;
  const poLevel1 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level1
  );
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );

  const renderIcon = useCallback(() => {
    if (
        poLevel1[plantObligationID]?.state === 6 &&
        poLevel1[plantObligationID]?.customState >= 150 &&
        poLevel3[plantObligationID]?.goalState === 6 &&
        poLevel3[plantObligationID]?.goalCustomState >= 150 &&
        poLevel3[plantObligationID]?.goalCustomState > poLevel1[plantObligationID]?.customState 
    ) {
      return (
        <AppRemixIcon
          icon="alert"
            title={ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="saica.goal.custom.state.less.than.custom.state" />
            )}
            color={colors.danger}
        />
      );
    }

    return null;
  }, [poLevel1, poLevel3, plantObligationID]);

  return renderIcon();
}
